<template>
  <div class="ota-upgrade">
    <a-card>
      <a-tabs v-model:activeKey="tabKey">
        <a-tab-pane key="list" tab="升级包列表">
          <div class="search-bar">
            <a-form layout="inline">
              <a-form-item label="产品">
                <a-input style="width: 180px" placeholder="" />
              </a-form-item>
              <a-form-item label="升级包名称">
                <a-input style="width: 180px" placeholder="请输入升级包名称" />
              </a-form-item>
              <a-form-item>
                <a-button type="primary">查询</a-button>
              </a-form-item>
              <a-form-item>
                <a-button>重置</a-button>
              </a-form-item>
            </a-form>
          </div>
          <div class="table-bar">
            <a-button type="primary">新增</a-button>
            <div class="table-tools">
              <a-button type="text">
                <font-awesome-icon icon="fa-solid fa-rotate-right" />
              </a-button>
              <a-button type="text">
                <font-awesome-icon icon="fa-solid fa-table-cells-large" />
              </a-button>
              <a-button type="text">
                <font-awesome-icon icon="fa-solid fa-arrows-up-to-line" />
              </a-button>
              <a-button type="text">
                <font-awesome-icon icon="fa-solid fa-gear" />
              </a-button>
            </div>
          </div>
          <a-table :columns="columns" :data-source="[]" :pagination="false" style="margin-top: 16px;">
            <template #emptyText>
              <a-empty description="暂无数据" />
            </template>
          </a-table>
        </a-tab-pane>
        <a-tab-pane key="module" tab="模块列表">
          <div class="search-bar">
            <a-form layout="inline">
              <a-form-item label="模块名称">
                <a-input style="width: 180px" placeholder="请输入模块名称" />
              </a-form-item>
              <a-form-item>
                <a-button type="primary">查询</a-button>
              </a-form-item>
              <a-form-item>
                <a-button>重置</a-button>
              </a-form-item>
            </a-form>
          </div>
          <div class="table-bar">
            <a-button type="primary">新增</a-button>
            <div class="table-tools">
              <a-button type="text">
                <font-awesome-icon icon="fa-solid fa-rotate-right" />
              </a-button>
              <a-button type="text">
                <font-awesome-icon icon="fa-solid fa-table-cells-large" />
              </a-button>
              <a-button type="text">
                <font-awesome-icon icon="fa-solid fa-arrows-up-to-line" />
              </a-button>
              <a-button type="text">
                <font-awesome-icon icon="fa-solid fa-gear" />
              </a-button>
            </div>
          </div>
          <a-table :columns="moduleColumns" :data-source="[]" :pagination="false" style="margin-top: 16px;">
            <template #emptyText>
              <a-empty description="暂无数据" />
            </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-card>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'
const tabKey = ref('list')
const columns = [
  { title: '升级包名称', dataIndex: 'name', key: 'name' },
  { title: '升级包版本号', dataIndex: 'version', key: 'version' },
  { title: '所属产品', dataIndex: 'product', key: 'product' },
  { title: '状态', dataIndex: 'status', key: 'status' },
  { title: '创建时间', dataIndex: 'createdAt', key: 'createdAt' },
  { title: '操作', dataIndex: 'action', key: 'action' }
]
const moduleColumns = [
  { title: '模块名称', dataIndex: 'name', key: 'name' },
  { title: '所属产品', dataIndex: 'product', key: 'product' },
  { title: '模块编码', dataIndex: 'code', key: 'code' },
  { title: '模块描述', dataIndex: 'desc', key: 'desc' },
  { title: '操作', dataIndex: 'action', key: 'action' }
]
</script>

<style lang="less" scoped>
.ota-upgrade {
  padding: 0 0 24px 0;
  .search-bar {
    margin-bottom: 16px;
    background: #fafbfc;
    padding: 16px 16px 0 16px;
    border-radius: 4px;
  }
  .table-bar {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    .table-tools {
      margin-left: auto;
      display: flex;
      gap: 8px;
    }
  }
  .empty-block {
    text-align: center;
    padding: 48px 0;
  }
}
</style> 